import { executeAccessRequestCapabilities } from '@trello/id-invitations-service';

export const canSelfJoin = async (
  idCloud: string | undefined,
): Promise<boolean> => {
  const capabilities = await executeAccessRequestCapabilities(idCloud);
  if (capabilities) {
    const accessLevelPass: boolean = ['EXTERNAL', 'INTERNAL'].includes(
      capabilities.userAccessLevel,
    );
    const directAccessPass = !!capabilities.resultsV2[
      `ari:cloud:jira-software::site/${idCloud}`
    ]?.some(
      (detail: { accessMode: string }) => detail.accessMode === 'DIRECT_ACCESS',
    );
    return accessLevelPass && directAccessPass;
  }

  return false;
};
